export const Fallback = () => {
  return (
    <div className='w-full min-h-[100svh] flex flex-col gap-1 items-center justify-center text-xl text-gray-800'>
      <span>오류가 발생했습니다.</span>
      <span>잠시 후 다시 시도해주세요.</span>
      <button className='bg-blue-500 text-white px-4 py-2 mt-8 rounded-md' onClick={() => {
        window.location.href = '/'
      }}>
        새로고침
      </button>
    </div>
  )
}
